import { Input, InputSize } from "shared/components";

type PopoverSearchInputProps = {
  id: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  focusOnMount?: boolean;
};

export const PopoverSearchInput = ({
  id,
  placeholder,
  value,
  onChange,
  onKeyDown,
  onBlur,
  focusOnMount
}: PopoverSearchInputProps) => {
  return (
    <div className="px-4 py-2.5 border-b border-alpha-40">
      <Input
        id={id}
        placeholder={placeholder}
        size={InputSize.SM}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        wrapperClassName="w-full"
        className="placeholder:text-content-200 placeholder:text-sm placeholder:font-medium !rounded-lg !mb-0 !px-[14px] !py-2.5"
        focusOnMount={focusOnMount}
      />
    </div>
  );
};
